<template>
    <div :class="cssClass">
        <v-radio-group
            v-model="model"
            :row="row"
            class="rtls-radio-group"
            :inline="inline"
            @update:model-value="onChange"
        >
            <template v-if="label" v-slot:label>
                <p v-if="label" class="checkboxes-list__label">
                    {{ toSentenceCase($t(label)) }}
                    <span v-if="isRequired" class="asterisk">*</span>
                </p>
            </template>
            <v-radio
                v-for="(option, index) in options"
                :key="option[itemValue]"
                :label="option[itemText]"
                :value="option[itemValue]"
                :disabled="isDisabled"
                :rules="rules"
                :hide-details="index < options.length - 1 || null"
                class="rtls-radio"
            />
        </v-radio-group>
    </div>
</template>

<script>
import vuexComponentMixin from '../../mixins/vuex-component';
import readonly from '@/js/mixins/readonly';

export default {
    mixins: [vuexComponentMixin, readonly],

    props: {
        options: Array,
        itemValue: {
            type: String,
            default: 'value',
        },
        itemText: {
            type: String,
            default: 'text',
        },
        cssClass: String,
        isRequired: {
            type: Boolean,
            default: false,
        },
        row: {
            type: Boolean,
            default: false,
        },
        inline: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['change'],
    computed: {
        isDisabled() {
            return this.disabled || this.isReadOnly;
        },
    },

    methods: {
        onChange(value) {
            this.$emit('change', value);
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.v-radio) {
    flex: 0 0 auto;
    margin-right: 1.6rem;
    padding: 0.2rem 0 0 0.2rem;
    .v-selection-control {
        &__wrapper {
            width: 1.7rem;
            height: 1.7rem;
            margin-right: 0.8rem;
            .mdi-radiobox-marked {
                color: #2f477c !important;
            }
            .v-icon {
                font-size: 2.4rem;
            }
        }
    }
}
</style>
